// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 48) return "static/js/48.b885b5076.chunk.js";
	if (chunkId === 196) return "static/js/196.b885b5076.chunk.js";
	if (chunkId === 386) return "static/js/386.b885b5076.chunk.js";
	if (chunkId === 315) return "static/js/315.b885b5076.chunk.js";
	if (chunkId === 12) return "static/js/12.b885b5076.chunk.js";
	if (chunkId === 848) return "static/js/848.b885b5076.chunk.js";
	if (chunkId === 492) return "static/js/492.b885b5076.chunk.js";
	if (chunkId === 564) return "static/js/564.b885b5076.chunk.js";
	if (chunkId === 591) return "static/js/591.b885b5076.chunk.js";
	if (chunkId === 852) return "static/js/852.b885b5076.chunk.js";
	if (chunkId === 612) return "static/js/612.b885b5076.chunk.js";
	if (chunkId === 700) return "static/js/700.b885b5076.chunk.js";
	if (chunkId === 449) return "static/js/449.b885b5076.chunk.js";
	if (chunkId === 372) return "static/js/372.b885b5076.chunk.js";
	if (chunkId === 925) return "static/js/925.b885b5076.chunk.js";
	if (chunkId === 429) return "static/js/429.b885b5076.chunk.js";
	if (chunkId === 956) return "static/js/956.b885b5076.chunk.js";
	if (chunkId === 402) return "static/js/402.b885b5076.chunk.js";
	// return url for filenames based on template
	return undefined;
};